import {getCookie} from './util';
import {COUPON_VIEW_KEY} from "../constants/constants";

var _push_custom_event_to_GA4 = function () {

    if (arguments.length < 1) {
        console.error('Please specify at least the first parameter for eventName.');
        return;
    } else if (arguments.length % 2 === 0) {
        console.error('The number of arguments must be odd. Arguments should be as followed: eventName, (param1, value1, param2, value2...). Keys/values are optional');
        return;
    }

    let pushContent = {
        'event': 'ga4Event',
        'eventName': arguments[0]
    }

    if (arguments.length > 1) {
        for (let i = 1; i < arguments.length; i += 2) {
            pushContent[arguments[i]] = arguments[i + 1];
        }
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(pushContent);
};

export function pushEventSingle(result) {
    _push_custom_event_to_GA4(result);
}

export function pushEventPageView() {
    _push_custom_event_to_GA4('page_view',
        'user_id', sid == null ? undefined : sid);
}


export function pushEventMultiple(detail, linkUrl) {
    _push_custom_event_to_GA4(
        'internal_promo_click',
        'internal_promo_placement', window.location.pathname,
        'internal_promo_detail', detail,
        'link_url', linkUrl
    );
}

export function pushEventFaq(category) {
    _push_custom_event_to_GA4(
        'faq_page_view',
        'faq_category', category
    );
}

export function pushEventLogin(userId, isConnectedWithCard) {
    _push_custom_event_to_GA4(
        'login',
        'user_id', userId,
        'user_segment_fidelity', isConnectedWithCard ? 'connected with card' : 'connected without card',
        'user_fidelity_program', 'Moi'
    );
}

export function pushEventSignUpSuccess(userId) {
    _push_custom_event_to_GA4(
        'sign_up',
        'user_id', userId,
        'user_segment_fidelity', 'connected without card',
        'user_fidelity_program', 'Metro et moi'
    );
}

export function pushEventFaqDetail(category, detail) {
    _push_custom_event_to_GA4(
        'faq_page_view',
        'faq_category', category,
        'faq_detail', detail
    );
}

export function pushEventLinkCard(step) {
    _push_custom_event_to_GA4(
        'card_link_intent',
        'step', step
    );
}

export function pushEventLightbox(lightboxDescription) {
    _push_custom_event_to_GA4(
        'lightbox_view',
        'description', lightboxDescription
    );
}

export function pushEventDisableCard(lostOrStolen) {
    _push_custom_event_to_GA4(
        'card_disable',
        'description',
        lostOrStolen ? 'lost or stolen' : 'other'
    );
}

export function pushEventCouponClip(couponTypeId, banner) {
    _push_custom_event_to_GA4(
        'coupon_clip',
        'coupon_id', couponTypeId,
        'coupon_banner_name', banner
    );
}

export function pushEventCouponUnclip(couponTypeId, banner) {
    _push_custom_event_to_GA4(
        'coupon_declip',
        'coupon_id', couponTypeId,
        'coupon_banner_name', banner
    );
}

export function pushEventClipAllCoupons(listOfCoupons) {
    pushEventSingle('coupon_clip_all');

    for (let coupon of listOfCoupons) {
        pushEventCouponClip(coupon.couponTypeId, coupon.bannerCode);
    }
}

export function pushEventCouponImpression(couponTypeId, couponBanner, couponExclusiveApp) {
    _push_custom_event_to_GA4(
        'coupon_view',
        'coupon_id', couponTypeId,
        'coupon_banner_name', couponBanner,
        'coupon_exclusif_app', couponExclusiveApp
    );
}

export function pushDataLayerCardCreateIntent() {
    _push_custom_event_to_GA4('card_create_intent');
}

export function pushEventNewsletterSubscribe(origin, newsletterName) {
    _push_custom_event_to_GA4(
        'newsletter_subscribe',
        'newsletter_name', newsletterName,
        'origin', origin
    );
}

export function pushEventErrorMessage(description) {
    _push_custom_event_to_GA4(
        'error_message',
        'description', description,
    );
}

export function pushEventCardCreate() {
    _push_custom_event_to_GA4(
        'card_create'
    );
}

export function initCybermetrie() {
    const $body = $("body");

    //////////////////////////////////////
    //Page view
    //////////////////////////////////////

    if (!getCookie('currentUrl')) {
        document.cookie = 'currentUrl=' + window.location.href;
        pushEventPageView();
    } else {
        if (window.location.href !== getCookie('currentUrl')) {
            pushEventPageView();
            document.cookie = 'currentUrl=' + window.location.href;
            Object.keys(localStorage).forEach(function (key) {
                if (key.includes(COUPON_VIEW_KEY)) localStorage.removeItem(key);
            });
        }
    }

    //////////////////////////////////////
    //to push signe event
    //<button data-event-result="$$$_custom_value_$$$">label</button>
    //////////////////////////////////////

    $body.on("click", "[data-event-result]", function () {
        let result = $(this).data("event-result");
        pushEventSingle(result);
    });

    //////////////////////////////////////
    //to push multiples events (promo banner)
    //<button data-event-promo="$$$_click_text_$$$">label</button>
    //////////////////////////////////////

    $body.on("click", "[data-event-promo]", function () {
        let detail = $(this).data("event-promo");
        let linkUrl = $(this).attr('href');
        pushEventMultiple(detail, linkUrl)
    });

    //////////////////////////////////////
    //to push event Link card
    //<button data-event-lightbox="$$$_DESCRIPTION_$$$">label</button>
    //////////////////////////////////////

    $body.on("click", "[data-event-lightbox]", function () {
        let lightboxDescription = $(this).data("event-lightbox");
        pushEventLightbox(lightboxDescription);
    });
}